"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffTableRowCell = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const _1 = require(".");
const TariffTableRowCell = (props) => {
    const { cell } = props;
    if (typeof cell === 'string' || typeof cell === 'number') {
        return (react_1.default.createElement("div", { className: `${_1.className}__cell` }, cell));
    }
    const { content, tariff } = cell;
    const classNames = (0, classFunctions_1.getClassNames)(`${_1.className}__cell`, [
        tariff ? `color-${tariff}` : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames }, content));
};
exports.TariffTableRowCell = TariffTableRowCell;
//# sourceMappingURL=Cell.js.map